import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import BulkSearchModal from '@/views/components/bulkSearchModal/index.vue';

var InventoryChangeLogPage = function (_super) {
  __extends(InventoryChangeLogPage, _super);

  function InventoryChangeLogPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.columns = [];
    _this.rowSelection = {};
    _this.warehouseList = [];
    _this.selectedList = [];
    _this.wpList = [];
    _this.loadingStatus = false;
    _this.limitMonthNum = 31 * 3;
    _this.applicationCodeList = [];
    _this.inventoryLogFieldEnum = [];
    _this.searchData = _this.getInitSearchData();
    _this.lastParams = {};
    _this.docValue = '';
    _this.total = 0;
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition(_this.limitMonthNum);
    return _this;
  }

  Object.defineProperty(InventoryChangeLogPage.prototype, "showWpList", {
    get: function get() {
      var _this = this;

      if (this.$util.isEmpty(this.searchData.warehouse_code)) {
        return this.wpList;
      }

      return this.wpList.filter(function (item) {
        return item.warehouse_code === _this.searchData.warehouse_code;
      });
    },
    enumerable: false,
    configurable: true
  });

  InventoryChangeLogPage.prototype.onDatetimeDefaultValueChange = function (arr) {
    if (arr.length) {
      this.searchData.create_date_from = this.$util.formatDateTime(arr[0]);
      this.searchData.create_date_end = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.create_date_from = '';
      this.searchData.create_date_end = '';
    }
  };

  InventoryChangeLogPage.prototype.onCodeFieldChange = function (value, oldValue) {
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition(this.limitMonthNum);
  };

  InventoryChangeLogPage.prototype.queryWpList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.common.queryAllWpList()];

          case 1:
            res = _a.sent();
            this.wpList = res.data || [];
            return [2];
        }
      });
    });
  };

  InventoryChangeLogPage.prototype.created = function () {
    var _this = this;

    this.columns = [{
      title: this.t('操作单号'),
      dataIndex: 'reference_no',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('操作类型'),
      dataIndex: 'application_code_text',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('商品编码'),
      dataIndex: 'product_sku',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('谷仓商品条码'),
      dataIndex: 'product_barcode',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('仓库（区域）'),
      dataIndex: 'warehouse',
      scopedSlots: {
        customRender: 'warehouse'
      }
    }, {
      title: this.t('物理仓'),
      dataIndex: 'wp_name',
      width: 200,
      scopedSlots: {
        customRender: 'wp_name'
      }
    }, {
      title: this.t('商品品质'),
      dataIndex: 'product_quanlity_text',
      filterEmpty: true
    }, {
      title: this.t('变动量'),
      dataIndex: 'quantity_variation',
      align: 'right',
      filterEmpty: true
    }, {
      title: this.t('备注'),
      dataIndex: 'remark',
      scopedSlots: {
        customRender: 'remark'
      }
    }, {
      title: this.t('操作时间'),
      dataIndex: 'ibl_add_time',
      filterEmpty: true
    }];
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: function onChange(selectedRowKeys) {
        _this.rowSelection.selectedRowKeys = _this.selectedList = selectedRowKeys;
      }
    };
    this.queryChangeLog();
    this.queryWarehouseList();
    this.queryWpList();
  };

  InventoryChangeLogPage.prototype.handleDblClick = function () {
    var bulkSearchRef = this.$refs.bulkSearchModal;
    bulkSearchRef.modalVisible = true;
    bulkSearchRef.bulkListStr = this.docValue;
  };

  InventoryChangeLogPage.prototype.handleBulkFeedback = function (bulkKeywords) {
    this.docValue = bulkKeywords;
  };

  InventoryChangeLogPage.prototype.queryChangeLog = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, list, total;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.rowSelection.selectedRowKeys = this.selectedList = [];
            this.searchData.code_value_list = this.docValue.length ? this.docValue.split(',') : [];
            this.lastParams = this.$util.deepCopy(this.searchData);
            return [4, this.$api.warehouse.queryChangeLogList(this.searchData)];

          case 1:
            data = _a.sent().data;
            list = data.list, total = data.total;
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  InventoryChangeLogPage.prototype.queryWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.common.queryAllWarehouseList({
              is_append_remark: false
            })];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.warehouseList = data;
            return [2];
        }
      });
    });
  };

  InventoryChangeLogPage.prototype.getInitSearchData = function () {
    return {
      page_index: 1,
      page_size: 10,
      wp_code_list: [],
      warehouse_code: undefined,
      code_field: 'reference_no',
      code_value_list: [],
      application_code: undefined,
      create_date_from: '',
      create_date_end: ''
    };
  };

  InventoryChangeLogPage.prototype.handlePageChange = function (val) {
    this.searchData.page_index = val;
    this.queryChangeLog();
  };

  InventoryChangeLogPage.prototype.handleTabChange = function (key) {
    this.searchData.wp_code_list = [];
    this.initPage();
    this.queryChangeLog();
  };

  InventoryChangeLogPage.prototype.initPage = function () {
    this.searchData.page_index = 1;
  };

  InventoryChangeLogPage.prototype.handleSearch = function () {
    this.initPage();
    this.queryChangeLog();
  };

  InventoryChangeLogPage.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.getInitSearchData();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition(this.limitMonthNum);
    this.docValue = '';
    this.$nextTick(function () {
      return _this.queryChangeLog();
    });
  };

  InventoryChangeLogPage.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, create_date_from, create_date_end, _b, code, data, message;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            postData = {};

            if (isAll) {
              postData = __assign({}, this.lastParams);
              delete postData.page_index;
              delete postData.page_size;
              postData["export"] = 1;
              postData.ibl_id_list = [];
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              _a = this.lastParams, create_date_from = _a.create_date_from, create_date_end = _a.create_date_end;
              postData["export"] = 2;
              Object.assign(postData, {
                create_date_from: create_date_from,
                create_date_end: create_date_end
              });
              postData.ibl_id_list = this.selectedList;
            }

            return [4, this.$api.warehouse.exportChangeLog(postData)];

          case 1:
            _b = _c.sent(), code = _b.code, data = _b.data, message = _b.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  __decorate([enumData('Outbound/ProductQualityEnum')], InventoryChangeLogPage.prototype, "orderProductQualityEnum", void 0);

  __decorate([enumData('Inventory/ApplicationCodeEnum')], InventoryChangeLogPage.prototype, "applicationCodeList", void 0);

  __decorate([enumData('Inventory/InventoryLogFieldEnum')], InventoryChangeLogPage.prototype, "inventoryLogFieldEnum", void 0);

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], InventoryChangeLogPage.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([Watch('searchData.code_field')], InventoryChangeLogPage.prototype, "onCodeFieldChange", null);

  __decorate([loading('loadingStatus')], InventoryChangeLogPage.prototype, "queryChangeLog", null);

  __decorate([userPrefPageSize('inventoryChangeLogList')], InventoryChangeLogPage.prototype, "getInitSearchData", null);

  InventoryChangeLogPage = __decorate([Component({
    components: {
      BulkSearchModal: BulkSearchModal
    }
  })], InventoryChangeLogPage);
  return InventoryChangeLogPage;
}(Vue);

export default InventoryChangeLogPage;